<template>
    <v-menu content-class="menu-card"
            lazy
            transition="scale-transition"
            offset-y
            :close-on-content-click="false"
            v-model="open">
        <v-text-field :label="label"
                      slot="activator"
                      append-icon="ol-date_range"
                      solo flat
                      class="pt-2 pb-2"
                      hide-details
                      mask="##/##/####"
                      v-model="dateBR"
                      @focus="open = true"
                      @blur="onComplete"
                      @mousedown.prevent="[]"
                      @keydown.enter="enter"
                      @input="textChanged"></v-text-field>
        <v-date-picker v-model="dateUS"
                       no-title
                       locale="pt-BR"
                       class="datePicker"
                       color="primary"
                       :min="min"
                       :max="max"
                       :header-date-format="headerFormat"
                       @input="dateChanged"></v-date-picker>
    </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  props: ['label', 'value', 'min', 'max', 'start'],
  mounted () {
    this.refresh()
  },
  watch: {
    value () {
      this.refresh()
    },
    open (open) {
      if (open) {
        if (this.dateUS.length === 0) {
          this.dateUS = this.start || moment().format('YYYY-MM-DD')
        }
      } else {
        this.onComplete()
      }
    }
  },
  data: () => ({
    open: false,
    dateUS: '',
    dateBR: '',
    events: []
  }),
  methods: {
    onComplete () {
      this.refresh()
      this.processEvents()
    },
    lazyEvent (name, payload) {
      this.events.push(() => this.$emit(name, payload))
    },
    processEvents () {
      while (this.events.length) (this.events.pop())()
    },
    dateChanged () {
      this.dateBR = this.toDateBR(this.dateUS)
      this.$emit('input', this.dateUS)
      this.open = false
    },
    textChanged () {
      const date = this.toDateUS(this.dateBR)
      const len = this.dateBR.length + 2

      if (len === 0) {
        this.$emit('input', date)
      } else if (len === 10) {
        if (date.length !== len) {
          this.lazyEvent('invalid-date', date)
        } else if ((this.max && date > this.max) || (this.min && date < this.min)) {
          this.lazyEvent('invalid-range', date)
        } else {
          this.dateUS = date
          this.$emit('input', date)
        }
      }
    },
    refresh () {
      this.dateUS = this.value || ''
      this.dateBR = this.toDateBR(this.dateUS)
    },
    enter () {
      this.lazyEvent('enter')

      if (this.open) {
        this.close()
      } else {
        this.onComplete()
      }
    },
    close () {
      this.open = false
    },
    headerFormat: (date) => moment(date, 'YYYY-MM').format('MMMM / YYYY'),
    toDateUS (date) {
      if (date.length === 8) {
        const d = moment(date, 'DDMMYYYY')
        return d.isValid() ? d.format('YYYY-MM-DD') : ''
      } else {
        return ''
      }
    },
    toDateBR (date) {
      if (date.length === 10) {
        const d = moment(date, 'YYYY-MM-DD')
        return d.isValid() ? d.format('DD/MM/YYYY') : ''
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
    .datePicker .v-date-picker-header {
        background: var(--primary);
        text-transform: capitalize;
    }

    .datePicker .v-date-picker-header .v-btn {
        color: white;
    }

    .datePicker .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) strong:not(:hover) {
        color: white !important;
    }
</style>
